import { __rest } from 'tslib';
import React from 'react';
import { Error } from '@10d/tend-ui-icons/Error';
import { useTheme } from '@10d/tend-ui-theme';
import cn from 'classnames';
import { Root } from './styled.js';
import styles from './Message.module.css.js';

const Message = React.forwardRef((_a, ref) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    const theme = useTheme();
    return (React.createElement(Root, Object.assign({}, props, { ref: ref, theme: theme, className: cn([styles['tend-ui-form-message-root'], className]) }),
        React.createElement(Error, { size: 16 }),
        children));
});
Message.displayName = 'Form.Message';

export { Message };
